import React, { useState } from "react";
import SideMenu from "../components/SideMenu";
import UserMenu from "../components/UserMenu";
import MainContent from "../components/MainContent";
import Header from "../components/Header";
import Footer from "../components/Footer";

const Dashboard = () => {
  const [isSideMenuOpen, setIsSideMenuOpen] = useState(false);

  return (
    <div className="flex flex-row h-screen">
      <SideMenu className="w-full md:w-64" />
      <div className="flex-1 flex flex-col overflow-hidden">
        <div className="shadow-sm">
          <Header />
        </div>

        <div className="flex flex-1 flex-col md:flex-row overflow-y-auto">
          <MainContent />
        </div>

        {/* Footer (Spans Only MainContent) */}
        <div className="p-0 bg-blue-100 text-center">
          <Footer />
        </div>
      </div>

      {/* Right Sidebar (Hidden on Mobile, Visible on Medium Screens and Above) */}
      <div className="hidden md:block w-64 h-full">
        <UserMenu />
      </div>

      {/* Mobile Bottom Navigation (Visible on Mobile, Hidden on Medium Screens and Above) */}
      <div className="fixed bottom-0 left-0 right-0 bg-white shadow-lg md:hidden">
        <div className="flex justify-around p-2">
          {/* Mobile Menu Items */}
          <button
            onClick={() => {
              /* Toggle Left Sidebar */
            }}
          >
            {/* Icon for Menu */}
          </button>
          <button
            onClick={() => {
              /* Toggle Right Sidebar */
            }}
          >
            {/* Icon for User Menu */}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
